module.exports = __webpack_public_path__ + "media/8.db2d0ab5.wav";